import { IAppointment } from './appointments'

export interface IAPICreateBlock {
  blocked_category_uuid: string
  person_uuid: string
  starts_at: string
  ends_at: string
  notes: string
  is_repeat: boolean
  repeat_week_interval: number
  repeat_stops_at: string | null
}

export interface IAPIUpdateBlock {
  blocked_category_uuid: string
  person_uuid: string
  starts_at: string
  ends_at: string
  notes: string
}

export interface IAPIBlock {
  uuid: string
  id: number
  name: string
  blocked_category_uuid: string
  color: string
  alt_color: string
  starts_at: string
  ends_at: string
  notes: string | null
  person_id: number
  person_uuid: string
  is_repeat: boolean
}

export interface IAPIAppointmentActivity {
  id: number
  uuid: string
  activity_id: number
  is_locked: boolean
  person_id: number
  starts_at: string
  ends_at: string
}

export interface IAPIAppointmentCustomer {
  uuid: string
  id: number
  address: string
  full_name: string
  image: string
  invoice_address: string
  invoice_location: string
  invoice_name: string
  invoice_postal: string
  invoice_vat_number: string
  is_man: string
  is_online_booking_blocked: boolean
  is_student: string
  is_top_customer: boolean
  postal: string
  search_string: string
  updated_at: string
  updated_timestamp: number
  birthday: null | string
  city: string
  email: string
  establishment_uuid: string
  first_name: string
  gender: null | string
  is_completed: boolean
  is_trusted: boolean
  language: string
  last_name: string
  loyalty_points: null | string
  organisation_uuid: string
  phone_home: null | string
  phone_mobile: null | string
  send_email: boolean
  send_newsletter: boolean
  send_sms: boolean
  street: string
  zipcode: string
}

export interface IAPICalendar {
  [key: string]: IApiCalendarDay
}

export interface IApiCalendarDay {
  appointments: IAPIAppointment[]
  blocked: []
  last_minutes: []
}

export type TAPIPaymentStatus =
  | 'canceled'
  | 'expired'
  | 'failed'
  | 'paid'
  | 'collected'
  | 'requested'

export type TApiReminderStatus =
  | 'unknown'
  | 'delivered'
  | 'bounced'
  | 'complaint'
  | 'processed'
  | 'sent'
  | 'read'
  | 'invalid'
  | 'black_listed'
  | 'failed'
  | 'no_credits'
  | 'clicked'
  | null

export interface IAPIUpdateAppointmentActivity {
  person_id?: number
  starts_at?: string
  ends_at?: string
  update_repeat_appointments?: false
  is_locked?: boolean
}

export interface IAPICreateAppointment {
  customer_uuid: string
  starts_at: string
  appointment_activities: IAPICreateAppointmentActivities[]
  is_repeat: boolean
  repeat_week_interval: number
  repeat_stops_at: string | null
  notes: string
}

interface IAPICreateAppointmentActivities {
  activity_uuid: string
  person_uuids: string[]
  is_locked: boolean
}

export interface IAPICreateAppointmentError {
  message: string
  type: 'transform_failed' | 'fetch_error' | 'exception' | 'not_found'
}

export interface IAPIAppointment {
  appointment_activities: IAPIAppointmentActivity[]
  appointment_customer_remarks: []
  customer: IAPIAppointmentCustomer
  starts_at: string
  ends_at: string
  id: number
  uuid: string
  is_deleted: boolean
  is_new_customer: boolean
  is_no_show: boolean
  is_online: boolean
  is_registered: boolean
  is_repeat: boolean
  notes: null | string
  payment_status: TAPIPaymentStatus
  remark: null | string
  reminder_status: TApiReminderStatus
  repeat_started_at: string
  repeat_stops_at: string
  repeat_week_interval: number
}

export interface IAPIAppointmentList {
  list: IAPIAppointment[]
  total: number
}

export const isInstanceOfAppointment = (object: any): object is IAppointment =>
  typeof object?.appointmentId === 'number' &&
  typeof object?.uuid === 'string' &&
  typeof object?.appointmentNotes === 'string'
